var InteractiveParameterElementAndInteractiveParameterCommonMethods = require('./InteractiveParameterElementAndInteractiveParameterCommonMethods');

/**
 * Параметры конструктора InteractiveParameterElement
 * @typedef {Object} InteractiveParameterElementConstructorParams
 * @property {jQuery} $element - jQuery-объект элемента
 * @property {string} [classActive] - Класс активного элемента
 * @property {string} [classHidden] - Класс скрытого элемента. Если не указан, используется механизм скрывания/показывания jQuery
 * @property {string} [disabledCursor] - Курсор недоступного элемента
 * @property {Function} [onClick] - Функция, вызываемая при нажатии на элемент
 * @property {*} [index] - Индекс элемента
 * @property {InteractiveParameter} [InteractiveParameter] - Объект интерактивного параметра
 */

/**
 * Элемент интерактивного параметра
 * @param {InteractiveParameterElementConstructorParams} params
 * @constructor
 */
function InteractiveParameterElement(params) {
    /**
     * Связанные элементы параметров
     * @type {InteractiveParameterElement[]}
     */
    this.related = [];
    /**
     * Недоступен ли элемент
     * @type {boolean}
     */
    this.disabled = false;
    /**
     * Нажат ли элемент
     * @type {boolean}
     */
    this.clicked = false;
    /**
     * jQuery-объект элемента
     * @type {jQuery}
     */
    this.$element = params.$element;
    /**
     * Класс скрытого элемента
     * @type {string|null}
     */
    this.classHidden = params.classHidden || null;
    /**
     * Скрыт ли элемент
     * @type {boolean}
     */
    this.hidden = this.classHidden ? this.$element.hasClass(this.classHidden) : false;
    /**
     * data-атрибуты элемента
     * @type {Object}
     */
    this.data = this.$element.data() || {};
    /**
     * Класс активного элемента
     * @type {string|null}
     */
    this.classActive = params.classActive || null;
    /**
     * Курсор недоступного элемента
     * @type {string|null}
     */
    this.disabledCursor = params.disabledCursor || null;
    /**
     * Изначальный курсор элемента в свойстве style
     * @type {string}
     */
    this.initialCursorInStyle = this.$element[0].style.cursor;
    /**
     * Функция, вызываемая при нажатии на элемент
     * @type {Function}
     */
    this.onClick = params.onClick || function(){};
    /**
     * Индекс элемента
     * @type {*|null}
     */
    this.index = params.index || null;
    /**
     * Объект InteractiveParameter элемента
     * @type {InteractiveParameter|null}
     */
    this.InteractiveParameter = params.InteractiveParameter || null;

    // Назначение обработчика нажатия
    this.$element.on('click', this.getClicked.bind(this));
}

InteractiveParameterElement.prototype = {
    /**
     * Метод добавляет связанный элемент параметра
     * @param {InteractiveParameterElement} InteractiveParameterElement
     */
    relateWith: function (InteractiveParameterElement) {
        if (this.related.indexOf(InteractiveParameterElement) === -1) {
            this.related.push(InteractiveParameterElement);
            InteractiveParameterElement.relateWith(this);
        }
    },
    /**
     * Метод делает элемент скрытым
     */
    getHidden: function () {
        if (!this.hidden) {
            if (this.classHidden) {
                this.$element.addClass(this.classHidden);
            } else {
                this.$element.hide();
            }
            this.hidden = true;
        }
    },
    /**
     * Метод делает элемент показанным
     */
    getShown: function () {
        if (this.hidden) {
            if (this.classHidden) {
                this.$element.removeClass(this.classHidden);
            } else {
                this.$element.show();
            }
            this.hidden = false;
        }
    },
    /**
     * Метод делает элемент активным
     */
    getActive: function () {
        if (this.classActive !== null && !this.$element.hasClass(this.classActive)) {
            this.$element.addClass(this.classActive);
        }
    },
    /**
     * Метод делает элемент неактивным
     */
    getInactive: function () {
        if (this.classActive !== null && this.$element.hasClass(this.classActive)) {
            this.$element.removeClass(this.classActive);
        }
    },
    /**
     * Метод делает элемент недоступным
     */
    getDisabled: function () {
        if (!this.disabled) {
            if (this.disabledCursor !== null) {
                this.$element.css('cursor', this.disabledCursor);
            }
            this.disabled = true;
        }
    },
    /**
     * Метод делает элемент доступным
     */
    getEnabled: function () {
        if (this.disabled) {
            if (this.disabledCursor !== null) {
                this.$element.css('cursor', this.initialCursorInStyle);
            }
            this.disabled = false;
        }
    },
    /**
     * Метод обрабатывает нажатие на элемент
     * Нажатие отрабатывает для не нажатых и доступных элементов
     * @param {boolean} [withNoHandling] - Пропустить ли вызов обработчика нажатия
     * @param {boolean} [allowDisabled] - Может ли отрабатывать нажатие для недоступного элемента
     */
    getClicked: function (withNoHandling, allowDisabled) {
        if (!this.clicked && (allowDisabled || !this.disabled)) {
            if (withNoHandling !== true) {
                this.onClick.apply(this);
            }
            this.clicked = true;
        }
    },
    /**
     * Метод делает элемент не нажатым
     */
    getUnclicked: function () {
        if (this.clicked) {
            this.clicked = false;
        }
    },
    /**
     * Метод вызывает метод с аргументами у элемента и связанных элементов
     * @type {applyToMethod}
     */
    applyToSelfAndRelated: InteractiveParameterElementAndInteractiveParameterCommonMethods.applyToSelfAndRelated,
    /**
     * Метод вызывает метод с аргументами у связанных элементов
     * @type {applyToMethod}
     */
    applyToRelated: InteractiveParameterElementAndInteractiveParameterCommonMethods.applyToRelated
};

module.exports = InteractiveParameterElement;



// WEBPACK FOOTER //
// ./assets/javascript/interactive_parameters/module/InteractiveParameterElement.js